import { render, staticRenderFns } from "./CallsignsAdminTable.vue?vue&type=template&id=13cec1cc&"
import script from "./CallsignsAdminTable.vue?vue&type=script&lang=js&"
export * from "./CallsignsAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports